module.exports = __webpack_public_path__ + "static/delivery-599b685a6c8da0293bf3e8521b94b29b.png";